import { useState, useEffect } from 'react';
import { DEBOUNCE_TIME } from 'utils/constant';

export function useDebounce(value:string, delay:number = DEBOUNCE_TIME) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timerId);
    };
  }, [value, delay]);

  return debouncedValue;
}